export default __webpack_public_path__ + "static/media/cup.f1e7fa2c.png";